/** Do zrušení: všichni uživatelé mají Pro (plná funkcionalita). Ponechat true = Pro pro všechny, false = běžné chování dle wedding.plan. */
export const ALL_USERS_PRO_PROMO = true;

export const SECTIONS = [
  'dashboard',
  'timeline',
  'divider_1',
  'tasks',
  'schedule',
  'entertainment',
  'divider_2',
  'guests',
  'seating',
  'divider_3',
  'budget',
  'divider_4',
  'vendors',
  'rings',
  'divider_5',
  'ceremony',
  'divider_6',
  'notes',
  'templates',
  'divider_7',
  'settings'
] as const;

export type SectionKey = typeof SECTIONS[number];

export const PHASES = [
  { key: 'early', months: '12–9' },
  { key: 'mid', months: '9–6' },
  { key: 'approaching', months: '6–3' },
  { key: 'final', months: '3–1' },
  { key: 'last_week', months: 'Last Week' },
  { key: 'today', months: 'Wedding Day' },
  { key: 'post_1_day', months: '1 Day After' },
  { key: 'post_1_week', months: '1 Week After' },
  { key: 'post_1_month', months: '1 Month After' }
] as const;

export type PhaseKey = typeof PHASES[number]['key'];

export const slugify = (text: string) => {
  return text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-');
};
